<zag-card variant="interactive" (cardClick)="onCardClick()">
  <!-- Header: Avatar, Name and optional Delete button -->
  <div card-header class="zag-card-header-content">
    <zag-avatar class="zag-card-avatar" [name]="fullName()" [src]="person().profilePicture" size="lg" />
    <div class="zag-card-header-text">
      <h3 class="zag-card-title">{{ fullName() }}</h3>
      <p class="zag-person-card__employee-number">{{ person().employeeNumber }}</p>
    </div>
    @if (showDelete()) {
    <button type="button" class="zag-person-card__delete-btn" [attr.aria-label]="deleteAriaLabel()" (click)="onDeleteClick($event)">
      <span zagIcon="delete"></span>
    </button>
    }
  </div>

  <!-- Body: Fixed height with date of birth, email, phone, team -->
  <div class="zag-person-card__body">
    <div class="zag-person-card__info-row">
      <span zagIcon="cake" class="zag-person-card__info-icon"></span>
      <span class="zag-person-card__info-text">{{ person().dateOfBirth | zagDate }}</span>
    </div>
    <div class="zag-person-card__info-row">
      <span zagIcon="mail" class="zag-person-card__info-icon"></span>
      <span class="zag-person-card__info-text">{{ person().email || '—' }}</span>
    </div>
    <div class="zag-person-card__info-row">
      <span zagIcon="phone" class="zag-person-card__info-icon"></span>
      <span class="zag-person-card__info-text">{{ person().phone || '—' }}</span>
    </div>
    <div class="zag-person-card__info-row">
      <span zagIcon="group" class="zag-person-card__info-icon"></span>
      <span class="zag-person-card__info-text">{{ person().team || '—' }}</span>
    </div>
  </div>
</zag-card>
